module.exports = __webpack_public_path__ + "static/media/magic-icon.5d720d26.svg";